import styled from 'styled-components'

export const StyledActiveCell = styled.div<{ active: boolean }>`
  font-weight: ${(props) => (props.active ? 'bold' : 'initial')};
  text-decoration: ${(props) => (props.active ? 'underline' : 'initial')};
`
